import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";

export function getAvailableReportingYears(): AxiosApiResponsePromise<number[]> {
	return axiosApi.get(`reports/available-years`);
}
